import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import {
  ISummaryHeaderCreationDeleteModel,
  ISummaryHeaderModel,
} from "../../models/summary.model";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircleIcon from "@mui/icons-material/Circle";
import styles from "./Summary.module.scss";
import SummaryGeneralInformation from "./accordionDetails/SummaryGeneralInformation";
import Empty from "./accordionDetails/Empty";
import SummaryDraft from "./accordionDetails/SummaryDraft";
import SummaryReview from "./accordionDetails/SummaryReview";
import SummaryLegal from "./accordionDetails/SummaryLegal";
import SummaryDraftApproval from "./accordionDetails/SummaryApprovers";
import SummaryFinalVersion from "./accordionDetails/SummaryFinalVersion";
import SummaryDeleteApproval from "./accordionDetails/SummaryDeleteApproval";

interface Props {
  accordionName: keyof ISummaryHeaderCreationDeleteModel;
  summaryHeader: ISummaryHeaderModel;
  expanded: boolean;
  handleChange: (
    panel: string
  ) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
}

const SummaryAccordion: React.FC<Props> = ({
  accordionName,
  summaryHeader,
  expanded,
  handleChange,
}) => {
  const { t } = useTranslation();

  const contentDetails = () => {
    switch (accordionName) {
      case "generalInformation":
        return (
          <SummaryGeneralInformation
            publicationId={summaryHeader.publicationId}
            expanded={expanded}
          />
        );
      case "draft":
        return (
          <SummaryDraft
            publicationId={summaryHeader.publicationId}
            expanded={expanded}
            isFinal={false}
          />
        );
      case "reviewers":
        return (
          <SummaryReview
            publicationId={summaryHeader.publicationId}
            expanded={expanded}
          />
        );
      case "legalComments":
        return (
          <SummaryLegal
            publicationId={summaryHeader.publicationId}
            expanded={expanded}
          />
        );
      case "finalDraft":
        return (
          <SummaryDraft
            publicationId={summaryHeader.publicationId}
            expanded={expanded}
            isFinal={true}
          />
        );
      case "draftApproval":
        return (
          <SummaryDraftApproval
            publicationId={summaryHeader.publicationId}
            expanded={expanded}
          />
        );
      case "deleteApproval":
        return (
          <SummaryDeleteApproval
            publicationId={summaryHeader.publicationId}
            expanded={expanded}
          />
        );
      case "finalVersion":
        return (
          <SummaryFinalVersion
            publicationId={summaryHeader.publicationId}
            expanded={expanded}
          />
        );
      case "finalVersionApproval":
        return (
          <SummaryDraftApproval
            publicationId={summaryHeader.publicationId}
            expanded={expanded}
            isFinal
          />
        );
      default:
        return <Empty messge="Section in construction" />;
    }
  };

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange(accordionName)}
      square
      disableGutters
    >
      <AccordionSummary
        aria-controls={`panel-content-${accordionName}`}
        id={`panel-header-${accordionName}`}
        expandIcon={<ExpandMoreIcon />}
      >
        <label>
          {summaryHeader.headers[accordionName] ? (
            <CheckCircleIcon className={styles.completed} />
          ) : (
            <CircleIcon className={styles.pending} />
          )}{" "}
          {t(`summaryTitles.${accordionName}`)}
        </label>
      </AccordionSummary>
      <AccordionDetails>{contentDetails()}</AccordionDetails>
    </Accordion>
  );
};

export default SummaryAccordion;
